module.exports = __webpack_public_path__ + "static/bg4-90260a9bc020aff2b9b8a01f6f6f0cbf.jpg";